import {
  IListWorkflowTemplateLinkResponse,
  TGetWorkflowTemplateLinkListParams,
} from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

export const useWorkflowTemplateLinks = (
  queryParams?: TGetWorkflowTemplateLinkListParams,
  options: { enabled?: boolean } = {}
) => {
  const query = new URLSearchParams();
  if (queryParams?.workflowTemplateId)
    query.append('workflowTemplateId', queryParams.workflowTemplateId);
  if (queryParams?.entityType)
    query.append('entityType', queryParams.entityType);
  if (queryParams?.entityId) query.append('entityId', queryParams.entityId);

  const queryString = query.toString();
  const url = `${BASE_URL}/links${queryString ? `?${queryString}` : ''}`;

  const { data, error, isLoading, mutate } =
    useSWR<IListWorkflowTemplateLinkResponse>(
      options.enabled === false ? null : url,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
